import { Typography } from "@mui/material";
import React from "react";
import { formatDate, formatDateMonth } from "../../utils/formatDate";

const TableContent = ({ fieldData, dateField }) => {

  console.log(fieldData, "fieldData",dateField,"dateField");
  return (
    <Typography
      sx={{
        padding: "8px 12px",
        textAlign: "left",
        borderRight: "1px solid #ddd",
        paddingLeft: dateField ? "16px" : "12px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        fontSize: "14px",
        color: "black",
      }}
    >
      {
        dateField
                ? formatDateMonth(dateField)
          : typeof fieldData === "object" &&
            fieldData !== null &&
            fieldData.name
          ? fieldData.name // Show the name field
          : fieldData===0 ? 0 : fieldData || "N/A" // Show the fieldData or "N/A" if it's falsy
      }
    </Typography>
  );
};

export default TableContent;
